<!-- La commune en titre, comme on l'appelle, dans la ligne de titre commune.
     Une feuille ouverte d'ici (adresse, gel) prend sa place le temps de
     l'édition : un seul voile à la fois (P4.3.1), puis la fiche revient. -->
<vw-toast-popup [isOpen]="isOpen && !isEditAddressOpen && !isFrostOpen" [title]="placeLabel"
  [subtitle]="'profile.garden.title' | translate" (close)="onClose()">
  <div class="flex flex-col gap-6 px-4 pb-8">

    <vw-list-section [title]="'profile.garden-sheet.address.title' | translate">
      @if (!isLocated) {
        <!-- Sans coordonnées, ni météo ni alertes : on le dit, et on mène à la correction. -->
        <vw-list-row tone="warn" [size]="64" [title]="'profile.garden-sheet.address.not-located.title' | translate"
          [subtitle]="'profile.garden-sheet.address.not-located.text' | translate" (rowClick)="isEditAddressOpen = true">
          <vw-location-home-icon vwListRowIcon class="block h-6 w-6" />
        </vw-list-row>
      }
      <vw-list-row [size]="64" [title]="addressLine" [subtitle]="'profile.garden-sheet.address.edit' | translate"
        (rowClick)="isEditAddressOpen = true">
        <vw-location-home-icon vwListRowIcon class="block h-6 w-6" />
      </vw-list-row>
    </vw-list-section>

    <!-- Rien tant que le climat n'est pas connu : pas de faux « Aucun climat renseigné ». -->
    @if (climateLabel || frostSummary) {
      <vw-list-section [title]="'profile.garden-sheet.climate.title' | translate">
        @if (climateLabel) {
          <vw-list-row [interactive]="false" [title]="'profile.addresses.climate' | translate"
            [subtitle]="climateLabel">
            <vw-alert-category-icon vwListRowIcon category="WEATHER" class="block h-6 w-6" />
          </vw-list-row>
        }
        @if (frostSummary) {
          <vw-list-row [size]="64" [title]="'profile.garden-sheet.frost.title' | translate" [subtitle]="frostSummary"
            (rowClick)="isFrostOpen = true">
            <vw-alert-category-icon vwListRowIcon category="SEASONAL" class="block h-6 w-6" />
          </vw-list-row>
        }
      </vw-list-section>
    }

    <!-- Mon potager montre l'adresse de l'app : on y mène pour elle seule. Une
         autre adresse dit ses zones sans promettre d'y aller. -->
    @if (zonesTitle) {
      <vw-list-section [title]="'profile.addresses.locations' | translate">
        <vw-list-row [size]="64" [interactive]="isAppAddress" [title]="zonesTitle" [subtitle]="zonesSubtitle"
          (rowClick)="openGarden()">
          <vw-garden-icon vwListRowIcon class="block h-6 w-6" />
        </vw-list-row>
      </vw-list-section>
    }
  </div>
</vw-toast-popup>

<vw-edit-user-adress-toast [isOpen]="isEditAddressOpen" [address]="detail ?? address"
  (close)="onEditAddressClosed($event)"></vw-edit-user-adress-toast>
<vw-frost-dates-toast [isOpen]="isFrostOpen" [frostDates]="frostDates" [city]="placeLabel"
  (close)="isFrostOpen = false"></vw-frost-dates-toast>
